module.exports = function store (state, emitter) {
  state.dragging = null,
  state.isRecording = false,
  state.recorder = null,
  state.mic = null,
  state.meter = null,
  state.recordingInterval = 0,
  state.recordingTimeout = 0,
  state.meterReads = [],
  state.recordedData = null,
  state.recordingSlice = 0
  state.recordedSample = null
  state.recordingNumber = 1
  state.recordingName = null

  emitter.on('updaterecordingname', (name) => {
    console.log('updaterecordingname')
    state.recordingName = name
  })
  emitter.on('startrecording', () => {
    console.log('startrecording')
    function stoprecording () {
      document.removeEventListener('mouseup', stoprecording)
      emitter.emit('stoprecording')
    }
    document.addEventListener('mouseup', stoprecording)
    
    window.Tone.start()
    state.isRecording = true
    state.recordingSlice = 0
    state.recorder = new Tone.Recorder()
    state.meter = new Tone.Meter()
    state.mic = new Tone.UserMedia().connect(state.meter)
    state.mic.connect(state.recorder)
    state.mic.open().then(() => {
      state.meterReads = []
      state.recorder.start()
    	state.recordingInterval = setInterval(
        () => {
          state.meterReads.push(state.meter.getValue())
          emitter.emit('render')
        },
        100
      )
    	state.recordingTimeout = setInterval(
        () => emitter.emit('stoprecording'),
        15 * 1000
      )
    }).catch(e => {
    	console.log("mic not open")
    })
  })
  emitter.on('stoprecording', () => {
    console.log('stoprecording')
    if (state.isRecording) {
      state.isRecording = false
      clearInterval(state.recordingInterval)
      clearTimeout(state.recordingTimeout)
      state.recorder.stop()
        .then(blob => blob.arrayBuffer())
        .then((buffer) => {
          const ctx = new AudioContext()
          return ctx.decodeAudioData(buffer)
        })
        .then((audioBuffer) => {
          state.recordedData = new Tone.ToneAudioBuffer(audioBuffer)
          state.recordedSample = new Tone.Player(state.recordedData).toDestination()
          emitter.emit('unfocus')
          emitter.emit('render')
        })
    }
  })

  emitter.on('slicewave', (e) => {
    console.log('slicewave')
    function getNormalizedWidth (e) {
      const bounds = e.target.getBoundingClientRect()
      return e.layerX / bounds.width
    }
    let position = getNormalizedWidth(e)
    state.recordingSlice = position
    emitter.emit('unfocus')
    emitter.emit('render')
  })

  emitter.on('startsampletest', () => {
    console.log('startsampletest')
    if (!state.recordedData) return
    state.recordedSample.loopStart = state.recordedData.duration * state.recordingSlice
    state.recordedSample.loop = true
    state.recordedSample.start(0)
  })
  emitter.on('stopsampletest', () => {
    if (!state.recordedSample) return
    state.recordedSample.loop = false
    emitter.emit('unfocus')
  })

  emitter.on('savesampletest', () => {
    console.log('savesampletest')
    const slicedBuffer = state.recordedData.slice(state.recordedData.duration * state.recordingSlice)
    const file = new Tone.Player(slicedBuffer).toDestination()
    const title = state.recordingName || `Recording ${state.recordingNumber}`
    const id = title.toLowerCase().split(' ').join('-')
    state.files.push({
      id: id,
      file: file
    })
    state.samples.unshift({
      mySample: true,
      id: id,
      name: title,
      file: file,
      category: 'loop'
    })
    state.recordingNumber += 1

    state.meterReads = []
    state.recordedData = null
    state.recordingSlice = 0
    state.recordedSample = null
    state.recordingName = null
    state.selectedCategory = null

    emitter.emit('togglesoundlibrary')
    emitter.emit('canceltutorial')

    document.querySelector('#sound-list').scroll({ top: 0 })
  })
}
